<template>
    <b-modal
        :id="id"
        title="History info"
        centered
        size="xl"
        @shown="onModalShown"
        @hidden="onModalHidden"
    >
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="fullName">
                    Full name
                </label>
                <input
                    id="fullName"
                    :value="item.user.fullName"
                    class="form-control"
                    type="text"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="productName">
                    Product
                </label>
                <input
                    id="productName"
                    :value="item.product.name"
                    class="form-control"
                    type="text"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="number">
                    Number
                </label>
                <input
                    id="number"
                    :value="item.number"
                    class="form-control"
                    type="number"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="status">
                    Status
                </label>
                <v-select
                    v-if="isStatusUpdateable"
                    v-model="formData.status"
                    :options="ALL_STATUSES"
                    :reduce="status => status.value"
                    label="text"
                    :clearable="false"
                />
                <input
                    v-else
                    id="status"
                    :value="getStatusText(item.status)"
                    class="form-control"
                    type="name"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="startDate">
                    Start date
                </label>
                <input
                    id="startDate"
                    :value="item.startDate || '-'"
                    class="form-control"
                    type="text"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="endDate">
                    End Date
                </label>
                <input
                    id="endDate"
                    :value="item.endDate || '-'"
                    class="form-control"
                    type="text"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="createdAt">
                    Created at
                </label>
                <input
                    id="createdAt"
                    :value="item.createdAt | formatDate"
                    class="form-control"
                    type="text"
                    disabled
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="returnedAt">
                    Returned at
                </label>
                <input
                    id="returnedAt"
                    :value="item.returnedAt | formatDate"
                    class="form-control"
                    type="text"
                    disabled
                />
            </div>
            <div class="form-group col-12">
                <h5 class="col-12 text-uppercase bg-light py-1">
                    Disclaimer
                </h5>
                <div v-html="item.disclaimer" />
            </div>
            <div v-if="item.signature" class="form-group col-12 clssimoto">
                <h5 class="col-12 text-uppercase bg-light py-1">
                    Signature
                </h5>
                <div class="d-flex justify-content-center">
                    <canvas style="border: solid 1px black;" />
                </div>
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    :disabled="formData.status === item.status"
                    type="button"
                    class="btn btn-success waves-effect waves-light mr-2"
                    @click="updateStatus"
                >
                    Save
                </button>

                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SignaturePad from 'signature_pad';

export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'loan-info-modal'
        },
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formData: {}
        };
    },

    computed: {
        ...mapGetters({
            PENDING_STATUS: 'loans/PENDING',
            ACTIVE_STATUS: 'loans/ACTIVE',
            ALL_STATUSES: 'loans/ALL_STATUSES'
        }),

        isStatusUpdateable() {
            return [this.PENDING_STATUS, this.ACTIVE_STATUS].includes(
                this.item.status
            );
        }
    },

    methods: {
        ...mapActions({
            updateLoanStatus: 'loans/updateStatus'
        }),

        close() {
            this.$bvModal.hide(this.id);
        },

        async onModalShown() {
            this.formData = {
                status: this.item.status
            };

            if (!this.item.signature) {
                return;
            }

            await this.$nextTick();

            const canvas = document.querySelector('canvas');
            const signaturePad = new SignaturePad(canvas);

            signaturePad.off();
            signaturePad.fromData(this.item.signature);
        },

        onModalHidden() {
            this.formData = {};
            this.editMode = false;
        },

        getStatusText(status) {
            const { text } = this.ALL_STATUSES.find(
                ({ value }) => value === status
            );

            return text;
        },

        async updateStatus() {
            try {
                const item = await this.updateLoanStatus({
                    id: this.item.id,
                    status: this.formData.status
                });

                this.$emit('item-updated', item);
                this.close();
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>
